import AddPatient from './add'

export default AddPatient
